import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyvalue'
})
export class KeyvaluePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const keyValues = [];
    Object.getOwnPropertyNames(value).forEach((key: string) =>
      keyValues.push({key: key, value: value[key]}));

    return keyValues;
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/keyvalue/keyvalue.pipe.ts